import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table deposit report view.
 * @extends JetView
 */
export default class recordTableDepositReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Window for advanced filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // Data table for details
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Version',
                        header: _('Versión'), // Version header
                        width: 150,
                        sort: 'int', // Sort by integer
                    },
                    {
                        id: 'DocumentUrl',
                        header: _('Url documento'), // Document URL header
                        width: 400,
                        sort: 'int',
                    },
                    {
                        id: 'EncryptionValue',
                        header: _('Encriptación'), // Encryption header
                        width: 250,
                        sort: 'int',
                    },
                    {
                        id: 'CreatedDate',
                        header: _('Fecha de creación'), // Creation date header
                        width: 150,
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            id: 'versionTable', // Main data table ID
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Version',
                    header: _('Versión'), // Version header
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'DocumentUrl',
                    header: _('Url documento'), // Document URL header
                    width: 400,
                    sort: 'int',
                },
                {
                    id: 'EncryptionValue',
                    header: _('Encriptación'), // Encryption header
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'CreatedDate',
                    header: _('Fecha de creación'), // Creation date header
                    width: 150,
                    sort: 'int',
                },
            ],
            pager: 'pagerV', // Pager for the data table
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/RegisteredDocument/GetVersion'; // API URL for fetching versions
        this.on(this.app, 'version:id', (Id) => {
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?id=' + Id); // Load new data based on the ID
            $$('dtDetails').clearAll(); // Clear details data table
            $$('dtDetails').load(url + '?id=' + Id); // Load details data based on the ID
        });
    }
}

// FILE DOCUMENTED
